import { Lock, Power } from "lucide-react";
import DeskConfirm from "@/components/crm/DeskConfirm";
import ProfilePhoto from "@/components/ui/ProfilePhoto";
import { useAuth } from "@/context/AuthContext";
import { useLock } from "@/context/LockContext";
import { avatarColorForSeed } from "@/lib/avatarColors";

function ChoiceCard({ icon: Icon, color, title, hint, disabled, onClick, testId }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} className="flex items-center text-left w-full disabled:opacity-45 disabled:cursor-not-allowed" data-testid={testId}
      style={{ gap: 12, background: "#121216", border: "1px solid #26262C", borderRadius: 10, padding: "10px 12px", transition: "border-color .12s, background-color .12s" }}
      onMouseEnter={(e) => { if (!disabled) e.currentTarget.style.borderColor = color; }} onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#26262C"; }}>
      <span className="inline-flex items-center justify-center shrink-0" style={{ width: 34, height: 34, borderRadius: 9, background: `${color}22` }}><Icon size={17} style={{ color }} /></span>
      <span className="min-w-0">
        <span className="block" style={{ fontSize: 12.5, fontWeight: 600, color: "#E8E8EC" }}>{title}</span>
        <span className="block" style={{ fontSize: 10.5, color: "#8A8A93", marginTop: 2 }}>{hint}</span>
      </span>
    </button>
  );
}

/** iter410 L3-9 (X3) — « Quitter Le Desk ? » : photo 64 px (anneau couleur utilisateur ; 4e endroit autorisé), « À bientôt, <Prénom> »,
 *  cartes Verrouiller (écran du code) / Se déconnecter ; Annuler par défaut, Échap = Annuler. */
export default function QuitDeskDialog({ open, onStay, onQuit }) {
  const { user } = useAuth();
  const { lock, enabled: lockEnabled } = useLock();
  if (!open) return null;
  const ring = avatarColorForSeed(user?.id || user?.email || "x").bg;
  const header = (
    <span className="inline-flex items-center justify-center rounded-full" style={{ padding: 3, border: `2px solid ${ring}` }} data-testid="quit-desk-photo-ring">
      <ProfilePhoto user={user} size={64} testid="quit-desk-photo" />
    </span>
  );
  return (
    <DeskConfirm open header={header} title={`À bientôt, ${user?.first_name || ""}`.trim()} subtitle="Quitter Le Desk ?" cancelOnly cancelLabel="Annuler" onClose={onStay} onConfirm={onStay} testId="quit-desk">
      <div className="grid" style={{ gap: 8 }}>
        <ChoiceCard icon={Lock} color="#A78BFA" title="Verrouiller" hint={lockEnabled ? "Retour rapide avec le code à 4 chiffres" : "Code à 4 chiffres non configuré (Paramètres › Mon profil)"} disabled={!lockEnabled}
          onClick={() => { onStay(); lock(); }} testId="quit-desk-lock" />
        <ChoiceCard icon={Power} color="#EF4444" title="Se déconnecter" hint="Nouveau code par e-mail au retour" onClick={onQuit} testId="quit-desk-logout" />
      </div>
    </DeskConfirm>
  );
}
